/**
 * Shared TinyMCE loader — uses local assets at /tinymce (no CDN).
 */

let tinymceScriptPromise;

export function loadTinyMce() {
  if (typeof window !== 'undefined' && window.tinymce) {
    return Promise.resolve(window.tinymce);
  }

  if (!tinymceScriptPromise) {
    tinymceScriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-portal-tinymce="1"]');
      if (existing) {
        existing.addEventListener('load', () => {
          if (window.tinymce) resolve(window.tinymce);
          else reject(new Error('TinyMCE script loaded but window.tinymce is missing'));
        });
        existing.addEventListener('error', () => reject(new Error('Failed to load TinyMCE from /tinymce/tinymce.min.js')));
        if (window.tinymce) resolve(window.tinymce);
        return;
      }

      const script = document.createElement('script');
      script.src = '/tinymce/tinymce.min.js';
      script.dataset.portalTinymce = '1';
      script.onload = () => {
        if (window.tinymce) resolve(window.tinymce);
        else reject(new Error('TinyMCE script loaded but window.tinymce is missing'));
      };
      script.onerror = () => reject(new Error('Failed to load TinyMCE from /tinymce/tinymce.min.js'));
      document.head.appendChild(script);
    });
  }

  return tinymceScriptPromise;
}

export const TINYMCE_BASE = {
  base_url: '/tinymce',
  suffix: '.min',
  branding: false,
  promotion: false,
};
